/* ================================================== */
/* ISOTOPE > Productions
/* ================================================== */

var $isotope,
	$sectionTitle,
	$categoriesList,
	filter = '*';

function getFilter(category) {
	$sectionTitle = $('.header__title .main'),
	$categoriesList = $('.header__productions');
	if (category !== null) {
		$sectionTitle.addClass('main--no-line');
		$categoriesList.attr('data-reset', 'enabled');
		if (category.indexOf(',') !== -1) {
			var filters = category.split(','),
				filter = '';
			for (var i = 0; i < filters.length; i++) {
				filter = filter + ((filter !== '*' && filter !== '') ? ', ' : '') + ('.' + filters[i]);
			}
		} else {
			filter = '.' + category;
		}
	} else {
		$sectionTitle.removeClass('main--no-line');
		$categoriesList.attr('data-reset', 'disabled');
		filter = '*';
	}
	return filter;
}

$(document).ready(function() {
	var $production = $('.child--productions'),
		$sectionTitle = $('.header__title .main'),
		$categoriesList = $('.header__productions'),
		$heading = $('.blocks__heading h2');

	if ($production.length) {
		// Init isotope
		var $isotopeEl = $('.blocks--isotope', $production);
		$isotope = $isotopeEl.isotope({
			filter: getFilter($.getUrlParam('category')), // Load categories from URL
			itemSelector: '.blocks__production',
			layoutMode: 'vertical',
			visibleStyle: {
				opacity: 1,
				transform: 'translateY(0)'
			},
			hiddenStyle: {
				opacity: 0,
				transform: 'translateY(0)'
			}
		});

		// Update list w/ header filters
		$('.trigger').click(function() {
			var activeAttr = 'data-active',
				$active = $('[' + activeAttr + ']');

			// Reset subfilter dropdown
			$('[data-filter]').addClass('hidden');

			// Reset filter
			if ($(this).is('[' + activeAttr + ']') || $(this).data('category') === 'reset') {
				$active.removeAttr(activeAttr);
				$heading.html($heading.data('default'));
				$isotope.isotope({ filter: '*' });
				$sectionTitle.removeClass('main--no-line');
				$categoriesList.attr('data-reset', 'disabled');
				updateQueryStringParam('category', '');

			// Apply filter
			} else if ($(this).data('category') !== 'reset') {
				$active.removeAttr(activeAttr);
				$(this).attr(activeAttr, '');
				filter = getFilter($(this).data('category'));
				$isotope.isotope({ filter: filter });
				$heading.html($('[data-active]').html());
				updateQueryStringParam('category', $(this).data('category'));

				if ($('[data-filter="' + $(this).data('category') + '"]').length) {
					$('[data-filter="' + $(this).data('category') + '"]').removeClass('hidden');
				}
			}
		});

		// Show subcategory dropdown
		if ($.getUrlParam('category') !== '*' && $('[data-filter="' + $.getUrlParam('category') + '"]').length) {
			$('[data-filter="' + $.getUrlParam('category') + '"]').removeClass('hidden');
		}

		// Update list w/ subfilter dropdown
		$('[data-filter] a').click(function() {
			filter = ($(this).data('category') === '*') ? getFilter($.getUrlParam('category')) : '.' + $(this).data('category');
			$heading.html($('[data-active]').html() + (($(this).data('category') !== '*') ? ' / ' + $(this).html() : ''));
			$isotope.isotope({ filter: filter });
		});

		// Reveal isotope after first init
		$isotopeEl.addClass('loaded');
	}
});